import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

const {
    APPLICATIONINSIGHTS_CONNECTION_STRING
} = require('./buildSettings.json');

export const browserHistory = createBrowserHistory({ basename: '' });

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
    config: {
        connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});
appInsights?.loadAppInsights();
appInsights.addTelemetryInitializer((env:ITelemetryItem) => {
    env.tags = env.tags || [];
});

export { reactPlugin, appInsights };